module.exports = __webpack_public_path__ + "media/notification2.3625c8a6.wav";